import { BrowserModule } from '@angular/platform-browser';
import { LOCALE_ID, NgModule } from '@angular/core';
import esCO from '@angular/common/locales/es-CO';
import esPE from '@angular/common/locales/es-PE';
// import esBO from '@angular/common/locales/es-BO';
// import esEC from '@angular/common/locales/es-EC';
// import esHN from '@angular/common/locales/es-HN';
// import esSV from '@angular/common/locales/es-SV';
// import esGT from '@angular/common/locales/es-GT';
import { registerLocaleData } from '@angular/common';
registerLocaleData(esCO);
registerLocaleData(esPE);
// registerLocaleData(esBO);
// registerLocaleData(esEC);
// registerLocaleData(esHN);
// registerLocaleData(esSV);
// registerLocaleData(esGT);

import { AppComponent } from './app.component';
import { routing } from './app.routing';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { InterceptorService } from './services/common/interceptor.service';
import { LoaderInterceptorService } from './services/common/loader-interceptor.service';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    routing,
    NgbModule,
    HttpClientModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule
  ],
  providers: [
    { provide: LOCALE_ID, useValue: 'es-Pe' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: InterceptorService,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptorService,
      multi: true
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
